import variable from "./variable";
import * as commonFuns from "./modules/styles/styles-functions";
import { detectOverWidth } from "./functions/detectOverWidth";

(function ($) {
    $(document).ready(() => {
        var csBanner_index = 0;

        $("#main-content section").each(function () {
            csBanner_index++;
            if ($(this).hasClass("csBanner")) {
                return false;
            }
        });
        $("section.csBanner .carousel-banner-top li").addClass("arc");

        // Use Custom Event from source/js/auto-scroll.js
        $("#main-content").on(
            "scroll_direction",
            function (e, direction, destination) {
                if (destination == csBanner_index) {
                    $("#simple-footer, #page-direction").addClass(
                        "last-section"
                    );

                    setTimeout(() => {
                        $("section.csBanner .carousel-banner-top li").addClass(
                            "arc"
                        );
                    }, 300);
                } else {
                    if (destination == 1) {
                        $(".container-main").addClass("inherit-menu");
                        $(".container-main").removeClass("white-menu");
                    } else {
                        $(".container-main").removeClass("inherit-menu");
                        $(".container-main").addClass("white-menu");
                    }

                    if (destination == 2) {
                        $(".img-container-ct").addClass("active");
                    } else {
                        $(".img-container-ct").removeClass("active");
                    }

                    $("#simple-footer, #page-direction").removeClass(
                        "last-section"
                    );
                    $("section.csBanner .carousel-banner-top li").removeClass(
                        "arc"
                    );
                }
            }
        );

        $(document).on("fullpage_loaded", () => {
            $(".owl-carousel").each((i, elm) => {
                $(elm).trigger("refresh.owl.carousel");
            });
        });

        initSliders();

        function initSliders() {
            $(".owl-carousel").each(function (index, el) {
                var nav,
                    dots = false;
                var lazyLoad = true;
                var loop = true;
                var customDots = false;
                var items = 1;
                var that = $(this);

                var responsive = {};
                var navText = [
                    "<i class='fa bg-chevron'></i>",
                    "<i class='fa bg-chevron'></i>",
                ];
                var then;

                var initFunction = function (e) {};

                if ($(this).hasClass("banners-top")) {
                    dots = true;
                    // then = '.banners-top';
                } else if (
                    $(this).hasClass("carousel-hotpot") ||
                    $(this).hasClass("carousel-why-wait") ||
                    $(this).hasClass("carousel-specifications")
                ) {
                    nav = dots = true;

                    if ($(this).hasClass("carousel-hotpot")) {
                        then = ".carousel-hotpot";
                    } else if ($(this).hasClass("carousel-why-wait")) {
                        then = ".carousel-why-wait";
                    } else if ($(this).hasClass("carousel-specifications")) {
                        then = ".carousel-specifications";
                    }
                } else if (
                    $(this).hasClass("carousel-recommend-option") ||
                    $(this).hasClass("carousel-banner-top")
                ) {
                    nav = true;
                    if ($(this).hasClass("carousel-recommend-option")) {
                        then = ".carousel-recommend-option";
                        items = 3;
                        responsive = {
                            0: { items: 1 },
                            576: { items: 2 },
                            769: { items: 3 },
                        };
                    }
                } else if (
                    $(this).hasClass("carousel-dtwice-reverse") ||
                    $(this).hasClass("carousel-dtwice-reverse-2")
                ) {
                    nav = dots = false;
                    loop = false;
                    if ($(this).hasClass("carousel-dtwice-reverse")) {
                        then = ".carousel-dtwice-reverse";
                    } else if ($(this).hasClass("carousel-dtwice-reverse-2")) {
                        then = ".carousel-dtwice-reverse-2";
                    }
                } else if ($(this).hasClass("half-makai-ct")) {
                    nav = true;
                    dots = false;
                }

                if ($(then).hasClass("carousel-recommend-option")) {
                    var owl = {
                        items: 3,
                        smartSpeed: 1100,
                        nav: nav,
                        navText: "",
                        loop: loop,
                        dots: dots,
                        lazyLoad: true,
                        lazyLoadEager: 1,
                        dotsContainer: customDots,
                        onInitialize: initFunction,
                        responsive: responsive,
                        onLoadedLazy: () => {
                            $(document).trigger("onOwlLoadedLazy");
                        },
                    };

                    var owl_carousel = $(then).owlCarousel(owl);
                    $("#owl-nav-custom .owl-prev").click(function () {
                        owl_carousel.trigger("prev.owl.carousel");
                    });

                    $("#owl-nav-custom .owl-next").click(function () {
                        owl_carousel.trigger("next.owl.carousel");
                    });
                } else {
                    let mouseDrag = true;
                    let touchDrag = true;

                    if ($(then).children().length === 1) {
                        loop = false;
                        mouseDrag = false;
                        touchDrag = false;
                    }

                    var owl = {
                        items: items,
                        smartSpeed: 1100,
                        nav: nav,
                        navText: navText,
                        loop: loop,
                        dots: dots,
                        mouseDrag: mouseDrag,
                        touchDrag: touchDrag,
                        lazyLoad: true,
                        lazyLoadEager: 1,
                        dotsContainer: customDots,
                        onInitialize: initFunction,
                        responsive: responsive,
                        onLoadedLazy: () => {
                            $(document).trigger("onOwlLoadedLazy");
                        },
                        onChanged: (event, a) => {
                            let element = event.target;
                            let page =
                                event.page.index < 0 ? 0 : event.page.index;
                            let el_parent = $(element);

                            // if (page < 0)

                            let keyObj = el_parent
                                .find(".owl-stage-outer .owl-item:not(.cloned)")
                                .eq(page)
                                .find(".bg_img")
                                .data("content");

                            let container_obj = el_parent.parent().parent();

                            container_obj
                                .find(".p-content-ct")
                                .each(function (key, value) {
                                    let el = $(value);
                                    el.hide();
                                });

                            container_obj
                                .find(".p-title-ct")
                                .each(function (key, value) {
                                    let el = $(value);
                                    el.hide();
                                });

                            container_obj
                                .find(".p-sub-title-ct")
                                .each(function (key, value) {
                                    let el = $(value);
                                    el.hide();
                                });

                            container_obj
                                .find(".infor-block-ct")
                                .each(function (key, value) {
                                    let el = $(value);
                                    el.hide();
                                });

                            container_obj
                                .find(".p-sub-infor-ct")
                                .each(function (key, value) {
                                    let el = $(value);
                                    el.hide();
                                });

                            container_obj.find("p.title-" + keyObj).fadeIn();
                            container_obj
                                .find("p.sub-title-" + keyObj)
                                .fadeIn();
                            container_obj.find("p.content-" + keyObj).fadeIn();
                            container_obj
                                .find(".infor-block-" + keyObj)
                                .fadeIn();
                            container_obj.find(".sub-infor-" + keyObj).fadeIn();
                        },
                    };

                    $(then).owlCarousel(owl);
                }
            });
        }

        percent_imgdot("#footer .content_block-quat-icon .content_block");

        resize_carousel();

        $(".carousel-specifications .owl-dot").addClass("o8");
        $(".cshotpot .owl-dot").addClass("o8");
        $(".cs-why-wait .owl-dot").addClass("o8");

        computePositionButtonBanner();

        var csBanner_LiImg = $(
            ".csBanner .carousel-banner-top.normal-bannertop li img"
        );
        csBanner_LiImg.each(function (index, el) {
            $(this).attr("src", $(this).attr("data-src"));
        });

        csBanner_LiImg.hover(
            function () {
                /* Stuff to do when the mouse enters the element */
                if (!$(this).parents("li").hasClass("active")) {
                    $(this).attr("src", $(this).attr("data-alt-src"));
                    $(this).css({
                        "max-height": "148px",
                        height: "148px",
                    });
                }
            },
            function () {
                /* Stuff to do when the mouse leaves the element */
                if (!$(this).parents("li").hasClass("active")) {
                    $(this).attr("src", $(this).attr("data-src"));
                    $(this).css("max-height", "");
                    $(this).css("height", "");
                }
            }
        );

        $(".carousel-banner-top .owl-dot__").on("click", function (event) {
            event.preventDefault();
            /* Act on the event */
            $(".carousel-banner-top .owl-dot__").each(function (index, el) {
                if ($(this).hasClass("active")) {
                    $(this).removeClass("active");
                    $(this)
                        .find("img")
                        .attr("src", $(this).find("img").attr("data-src"));
                }
            });
            $(this).addClass("active");
            $(this)
                .find("img")
                .attr("src", $(this).find("img").attr("data-alt-src"));

            var link_el = $(this).find("a");
            setTimeout(function () {
                var target = $(link_el).attr("target")
                    ? $(link_el).attr("target")
                    : "_self";
                var url = $(link_el).attr("href");
                var winbr = window.open(url, target);
                winbr.focus();
            }, 500);
        });

        $(".button-drop").click(function (event) {
            event.preventDefault();
            const that = $(this);

            if (detectOverWidth(992)) {
                // IF DESKTOP
                $.fn.fullpage.moveSectionDown();
            } else {
                // TODO: If mobile

                const next = that.closest("section").next("section");
                if (next.length > 0) {
                    $("html, body").animate(
                        {
                            scrollTop: next.offset().top,
                        },
                        800,
                        function () {}
                    );
                }
            }

            $(".csBanner .button-drop").fadeOut("slow");
        });

        $(".videomyI").each(function (index, el) {
            var video = $(this).attr("data-src");
            if (video != "") {
                $(this).append(
                    '<source src="' + video + '" type="video/mp4" >'
                );
                $(this).attr("data-src", "");
            }
        });

        var turn = 0;

        $("html").on("speed_network", function (e, speed) {
            initTheBanner(speed);
        });
    });

    $(window).on("resize", function () {
        resize_carousel();
        computePositionButtonBanner();
    });

    $(document).on("fullpage-loaded", function (e, section) {
        if ($(window).width() >= 992) {
            fullpageJS(section, once_360);
        } else {
            fullpageJS($("section.section"), once_360);
        }
    });

    $(window).on("load", function (event) {
        event.preventDefault();
        var active = $("section.active");
        fullpageJS(active, once_360);
    });

    //Sort random function
    function random(owlSelector) {
        var container = $(owlSelector.target);

        container
            .children()
            .sort(function () {
                return Math.round(Math.random()) - 0.5;
            })
            .each(function () {
                $(this).appendTo(container);
            });
    }

    function percent_imgdot(target) {
        var array_ft = [];
        var maxValue = 0;
        $(target).each(function (index, el) {
            $(this).addClass("dotx_" + index);
            array_ft.push($(this).find($(".ft")).data("ft"));
            maxValue = Math.max.apply(Math, array_ft);
        });
        $(target).each(function (index, el) {
            var ft = $(this).find($(".ft")).data("ft");
            var percent = (ft / maxValue) * 100;
            var result = (120 * (100 - percent)) / 100;

            if ($(this).hasClass("dotx_3")) {
                result = result * 1.26;
                $(this)
                    .find($("img"))
                    .css("padding-top", result + "px");
            } else {
                $(this)
                    .find($("img"))
                    .css("padding-top", result + "px");
            }
        });
    }

    /* */
    function var_window_(target, height_, after) {
        function var_window_height(if_, else_) {
            setTimeout(function () {
                if (if_ == true) {
                    let height = $(height_).outerHeight(true);
                    $(target).css("height", "calc(100vh - " + height + "px)");
                    $(after).height("100%");
                }
                if (else_ == true) {
                    $(target).css("height", "auto");
                    $(after).height($(target).height());
                }
            }, 500);
        }

        if (window.matchMedia("(min-width: 992px)").matches) {
            var_window_height(true);
        } else {
            var_window_height("", true);
        }
    }

    /* */
    function ATM_scroll(target, bool = false, button = "", event = "") {
        $(target).each(function (index, el) {
            function ATM(then, bool) {
                var B = $(then).find($(".scrollbar"))[0].scrollHeight;
                var A = $(then).height();
                if (A < B) {
                    $(then).hover(
                        function () {
                            $.fn.fullpage.setAllowScrolling(false);
                        },
                        function () {
                            $.fn.fullpage.setAllowScrolling(true);
                        }
                    );
                } else if (bool == true && A >= B) {
                    $(then).hover(
                        function () {
                            $.fn.fullpage.setAllowScrolling(true);
                        },
                        function () {
                            $.fn.fullpage.setAllowScrolling(true);
                        }
                    );
                }
            }

            ATM(this, bool);
            if (button != "" && event != "") {
                $(button).on(event, function (e) {
                    e.preventDefault();
                    ATM(target, bool);
                });
            }
        });
    }

    /* */
    function ATM_width(calc_A, calc_B, obj, method) {
        var calculator_B = 0;
        $(calc_B).each(function (index, el) {
            calculator_B += $(this).outerWidth(true);
        });
        var calc_A;
        if (method == "width") {
            calc_A = $(calc_A).width();
        } else if (method == "outerWidth") {
            calc_A = $(calc_A).outerWidth(true);
        }

        $(obj).css("width", "calc(" + calc_A + "px - " + calculator_B + "px )");
    }

    /* */
    function resize_carousel() {
        commonFuns.justifybutton(".banners-top");
        commonFuns.justifybutton("#footer .footer-logo .button");
        commonFuns.justifybutton(".cshotpot");

        var_window_(
            ".cs-why-wait .carousel-why-wait",
            ".cs-why-wait .block-hotpot-footer",
            ".cs-why-wait .bg_img"
        );
        var_window_(
            ".cshotpot .carousel-hotpot",
            ".cshotpot .block-hotpot-footer",
            ".cshotpot .bg_img"
        );

        ATM_scroll(".clone-double-twice .ATM", true);

        if (window.matchMedia("(min-width: 992px)").matches) {
        } else {
            $(".cs-why-wait .block-hotpot-footer .ATM").css("width", "auto");
            $(".cshotpot .block-hotpot-footer .ATM").css("width", "auto");
        }

        if (window.matchMedia("(max-width: 1100px)").matches) {
            var height_map =
                "calc( 100vh - " +
                $(".carousel_map .top").height() +
                "px - " +
                $(".carousel_map .bottom").height() +
                "px )";
            $(".carousel_map #map").css("height", height_map);
        } else {
            var height_map = "calc(100vh - 100px - 88px)";
            $(".carousel_map #map").css("height", height_map);
        }

        if (window.matchMedia("(max-width: 991px)").matches) {
            $(".carousel-hotpot").addClass("not-annotation");
        } else {
            $(".carousel-hotpot").removeClass("not-annotation");
        }
        $(".social-languagues ul").css(
            "width",
            $(".navbar #primary-menu").width()
        );

        $(".videomyI").css("width", "value");
    } /* END resize_carousel */

    function hotpot_spec(target, action, select = "") {
        $(target).on(action, select, function (e) {
            e.preventDefault();
            var thix;
            var thixNot;
            if (select == "") {
                thix = $(this).find(".owl-item.active .FEATURE__ a");
                thixNot = $(this).find(".owl-item").not(".active");
            } else {
                thix = $(this)
                    .closest(target)
                    .find(".owl-item.active .FEATURE__ a");
                thixNot = $(this)
                    .closest(target)
                    .find(".owl-item")
                    .not(".active");
            }
            thix.each(function (index, el) {
                $(this).attr("style", $(this).attr("data-style-e"));
            });

            thixNot.each(function (index, el) {
                $(this).find("a").attr("style", "");
            });
        });
    }

    var once_360 = 0;

    function fullpageJS(section, once_360) {
        if ($(section).hasClass("cs-free-style")) {
            $(".cs-free-style .videomyI").each(function (index, el) {
                $(this)[0].play();
            });
        } else if ($(section).hasClass("csBanner")) {
            $(".csBanner .videomyI").each(function (index, el) {
                $(this)[0].play();
            });
            setTimeout(function () {
                $(".csBanner .button-drop").fadeIn("slow");
            }, 300);
        } else if ($(section).hasClass("cshotpot")) {
            // $('section.cshotpot').addClass('active_v2');
            $(".carousel-hotpot .owl-item.active .FEATURE__ a").each(function (
                index,
                el
            ) {
                $(this).attr("style", $(this).attr("data-style-e"));
            });

            hotpot_spec(".carousel-hotpot", "dragged.owl.carousel");
            hotpot_spec(".carousel-hotpot", "click", ".owl-next, .owl-prev");
            hotpot_spec(".carousel-hotpot", "click", ".owl-dot");
        } else {
            $(".carousel-hotpot .FEATURE__ a").attr("style", "");
        }

        if ($(section).hasClass("cs-matterport")) {
            var xrc = $(".cs-matterport .content").attr("data-src");
            if (xrc != "") {
                $(".cs-matterport .content").attr("src", xrc);
                $(".cs-matterport .content").attr("data-src", "");
            }
            if ($(".cs-matterport .maskTRP .d").hasClass("d-none")) {
                $("#header .TRP_right").removeClass("d-none");
            } else {
                $("#header .TRP_right").addClass("d-none");
            }
            $(".cs-matterport .maskTRP label").removeClass("d-none");
            $(".cs-matterport .maskTRP").on("click", function (event) {
                if ($("#header .TRP_right").hasClass("active")) {
                    $("#header .TRP_right").removeClass("active");
                }
                $(this).css("display", "none");
                $(this).find("div").addClass("d-none");
                $("#header .TRP_right").removeClass("d-none");
                once_360 = 1;
            });

            $("#header .TRP_right").on("click", function (e) {
                e.preventDefault();
                $(".cs-matterport .maskTRP").css("display", "block");
                $(this).addClass("active");
            });
            if (once_360 == 1) {
                $("#header .TRP_right").removeClass("d-none");
            }
        } else {
            $("#header .TRP_right").addClass("d-none");
        }
    }

    jQuery(document.documentElement).keyup(function (event) {
        var owl = jQuery(".fullscreen-section.active .owl-carousel");

        // handle cursor keys
        if (event.keyCode == 37) {
            owl.find(".owl-prev").trigger("click");
        } else if (event.keyCode == 39) {
            owl.find(".owl-next").trigger("click");
        }
    });

    function initTheBanner(speed) {
        var bannerElement = $(".banners-top");

        if ($(".carousel-banner-top").length > 0) {
            if (banner_background.length > 0) {
                if (
                    (speed == "3g" && banner_background.length > 1) ||
                    $(window).width() < 992
                ) {
                    let new_banner_background = [];
                    banner_background.forEach(function (item, index) {
                        if (item.image_or_video.type != "video") {
                            new_banner_background.push(item);
                        }
                    });
                    banner_background = new_banner_background;
                }
                var random = getRndInteger(
                    0,
                    banner_background.length,
                    "banner-top"
                );
                var randomize = banner_background[random];

                if (randomize.image_or_video.type == "video") {
                    bannerElement.prepend(
                        '<video class="videomyI fullscreen-section bg_img dot_img lazy-load-bg-image z-index-large" autoplay muted loop src="' +
                            randomize.image_or_video.url +
                            '"></div>'
                    );
                } else if (randomize.image_or_video.type == "image") {
                    let the_using_url = randomize.image_or_video.url;

                    if ($(window).width() < 992) {
                        the_using_url =
                            randomize.image_or_video.sizes.medium_large;
                    }

                    bannerElement.prepend(
                        '<div class="fullscreen-section bg_img dot_img lazy-load-bg-image" style="background-image: url(' +
                            the_using_url +
                            ')"></div>'
                    );
                }
            }
        }
    }

    function computePositionButtonBanner() {
        $(".banners-top .content_block").css("bottom", 132 + 80);
    }

    /**
     * Function name: getRndInteger
     *
     * Description: return random one number but this have condition is previous value random had been save in cookie for one by one slider
     *
     * @param {integer} min
     * @param {integer} max
     * @param {string} saveCookie
     * @returns integer*
     */
    function getRndInteger(min, max, saveCookie) {
        var random_value = Math.floor(Math.random() * (max - min)) + min;
        return random_value;
    }

    function iframeHandle() {
        $("iframe").each(function (index, html) {
            let iframe = $(html);

            let src = iframe.attr("src");

            if (src) {
                let dview = src.indexOf("3dview");

                if (dview > -1) {
                    iframe
                        .parent()
                        .addClass("parent-iframe")
                        .append(
                            '<div class="iframe-layer"><span class="iframe-layer__open">Click to View</span></div><span class="iframe-close">Close</span>'
                        );
                }
            }
        });

        $(".iframe-layer__open").click(function () {
            let that = $(this);
            that.closest(".iframe-layer").hide();

            $(".iframe-close").show();
        });

        $(".iframe-close").click(function () {
            let that = $(this);
            that.closest(".parent-iframe").find(".iframe-layer").show();

            $(".iframe-close").hide();
        });
    }

    iframeHandle();
})(jQuery);
